// components/Footer.js
import React from 'react';
import ScrollAnimation from './ScrollAnimation';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-gray-900 text-white py-12">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                    {/* Logo y eslogan */}
                    <ScrollAnimation>
                        <div className="col-span-1 md:col-span-2">
                            <h3 className="text-2xl font-bold font-poppins mb-4 text-cyan">Iron Five</h3>
                            <p className="text-gray-300 font-lato mb-4">
                                Tecnología con propósito público. Soluciones digitales para un Estado más inteligente.
                            </p>
                            <div className="flex space-x-4">
                                <div className="w-10 h-10 bg-cyan rounded-full flex items-center justify-center hover:bg-cyan/80 transition-colors cursor-pointer">
                                    <span className="font-bold text-white">in</span>
                                </div>
                                <div className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-gray-600 transition-colors cursor-pointer">
                                    <span className="text-white">f</span>
                                </div>
                                <div className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-gray-600 transition-colors cursor-pointer">
                                    <span className="text-white">𝕏</span>
                                </div>
                            </div>
                        </div>
                    </ScrollAnimation>

                    {/* Enlaces rápidos */}
                    <ScrollAnimation delay={0.2}>
                        <div>
                            <h4 className="text-lg font-semibold font-montserrat mb-4 text-cyan">Enlaces rápidos</h4>
                            <ul className="space-y-2">
                                <li>
                                    <a href="#quienes-somos" className="text-gray-300 hover:text-cyan transition-colors font-lato">
                                        Quiénes somos
                                    </a>
                                </li>
                                <li>
                                    <a href="#servicios" className="text-gray-300 hover:text-cyan transition-colors font-lato">
                                        Servicios
                                    </a>
                                </li>
                                <li>
                                    <a href="#metodologia" className="text-gray-300 hover:text-cyan transition-colors font-lato">
                                        Metodología
                                    </a>
                                </li>
                                <li>
                                    <a href="#contacto" className="text-gray-300 hover:text-cyan transition-colors font-lato">
                                        Contacto
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </ScrollAnimation>

                    {/* Contacto */}
                    <ScrollAnimation delay={0.3}>
                        <div>
                            <h4 className="text-lg font-semibold font-montserrat mb-4 text-cyan">Contacto</h4>
                            <ul className="space-y-3">
                                <li className="flex items-start">
                                    <span className="text-cyan mr-2">📧</span>
                                    <span className="text-gray-300 font-lato text-sm">
                                        <a href={'mailto:hola.ironfive@gmail.com'}>hola.ironfive@gmail.com</a>
                                    </span>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-cyan mr-2">🌐</span>
                                    <span className="text-gray-300 font-lato text-sm">www.ironfive.com</span>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-cyan mr-2">📍</span>
                                    <span className="text-gray-300 font-lato text-sm">Buenos Aires, Argentina</span>
                                </li>
                            </ul>
                        </div>
                    </ScrollAnimation>
                </div>

                {/* Línea separadora */}
                <div className="border-t border-gray-700 mt-8 pt-8">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <ScrollAnimation delay={0.4}>
                            <p className="text-gray-400 font-lato text-sm text-center md:text-left">
                                &copy; {currentYear} Iron Five. Todos los derechos reservados.
                            </p>
                        </ScrollAnimation>
                        <ScrollAnimation delay={0.5}>
                            <div className="flex space-x-6 mt-4 md:mt-0">
                                <a href="#" className="text-gray-400 hover:text-cyan transition-colors text-sm font-lato">
                                    Política de privacidad
                                </a>
                                <a href="#" className="text-gray-400 hover:text-cyan transition-colors text-sm font-lato">
                                    Términos de servicio
                                </a>
                            </div>
                        </ScrollAnimation>
                    </div>
                </div>

                {/* Mensaje final */}
                <ScrollAnimation delay={0.6}>
                    <div className="text-center mt-6">
                        <p className="text-cyan font-montserrat text-sm">
                            Códigos que mejoran la gestión pública.
                        </p>
                    </div>
                </ScrollAnimation>
            </div>
        </footer>
    );
};

export default Footer;
